import { Pipe, PipeTransform } from '@angular/core';
import {JackpotConfigService} from './_services/jackpotConfig.service';

@Pipe({
    name: 'jackpot',
    pure: true
})
export class JackpotPipe implements PipeTransform {
    config: any;

    constructor(public jackpotConfig: JackpotConfigService) {
        this.downloadFromService();
        // this.config = JSON.parse('{"en-ca":{"millionCharToCut":6,"billionCharToCut":10,"currencyPosition":"left","millionSeparator":".","billionSeparator":".","thousandSeparator":",","defaultSeparator":",","spaceAfterCurrency":false,"spaceBeforeCurrency":false},"de":{"million":"Millionen","billion":"Milliarden","millionCharToCut":7,"billionCharToCut":11,"currencyPosition":"right","millionSeparator":",","billionSeparator":",","thousandSeparator":".","defaultSeparator":".","spaceAfterCurrency":false,"spaceBeforeCurrency":true},"de-at":{"millionCharToCut":6,"billionCharToCut":12,"currencyPosition":"left","millionSeparator":",","billionSeparator":",","thousandSeparator":" ","defaultSeparator":"\u00a0","spaceAfterCurrency":true,"spaceBeforeCurrency":false},"en":{"million":"Million","billion":"Billion","millionCharToCut":6,"billionCharToCut":10,"currencyPosition":"left","millionSeparator":".","billionSeparator":".","thousandSeparator":",","defaultSeparator":",","spaceAfterCurrency":false,"spaceBeforeCurrency":false},"en-nz":{"millionCharToCut":6,"billionCharToCut":10,"currencyPosition":"left","millionSeparator":".","billionSeparator":".","thousandSeparator":",","defaultSeparator":",","spaceAfterCurrency":false,"spaceBeforeCurrency":false},"en-ie":{"millionCharToCut":6,"billionCharToCut":10,"currencyPosition":"left","millionSeparator":".","billionSeparator":".","thousandSeparator":",","defaultSeparator":",","spaceAfterCurrency":false,"spaceBeforeCurrency":false},"default":{"million":"Million","billion":"Billion","millionCharToCut":6,"billionCharToCut":10,"currencyPosition":"left","millionSeparator":".","billionSeparator":".","thousandSeparator":",","defaultSeparator":",","spaceAfterCurrency":false,"spaceBeforeCurrency":false}}');
    }

    downloadFromService () {
        if (this.jackpotConfig.downloadedData) {
                this.config = this.jackpotConfig.jackpotConfig;
        } else {
            setTimeout(() => {
                this.downloadFromService();
            }, 500);
        }
    }



    transform(value: any, country?: any, currency?: any, pageLanguage?: any, cuttedVersion?: boolean, hideCurrency?: boolean): any {
        if (this.config === undefined) {
            this.downloadFromService();
        }
            let result = '';
            let textValue = '';
            if (!pageLanguage) pageLanguage = 'default';
            if (value) {
                const splitedValue = value.replace(currency + ' ', '').replace(currency, '');
                const cleanValue = value.replace(/[.,\s]/g, '').replace(currency, '');

                if (cleanValue >= 1000000000) {
                    textValue = 'billion';
                } else if (cleanValue >= 1000000 && cleanValue < 1000000000) {
                    textValue = 'million';
                }
                if (this.config && this.config[country] && this.config[country]['currencyPosition'] && this.config[country]['currencyPosition'] === 'left') {
                    if (this.config[country]['spaceBeforeCurrency']) result += ' ';
                    if (!hideCurrency) {
                      result += currency;
                    }
                    if (this.config[country]['spaceAfterCurrency']) result += ' ';
                }
                if (textValue !== '') {
                    result += splitedValue.substring(0, splitedValue.length - this.config[country][textValue + 'CharToCut'])
                        .replace(this.config[country]['defaultSeparator'] + '0', '')
                        .replace(this.config[country]['defaultSeparator'], this.config[country]['millionSeparator']);
                } else if (textValue === '' || cuttedVersion) {
                    result += splitedValue.replace(this.config[country]['defaultSeparator'], this.config[country]['thousandSeparator']);
                }
                if (!cuttedVersion && textValue !== '') {
                    result += ' ' + this.config[pageLanguage][textValue];
                }
                if (this.config[country]['currencyPosition'] === 'right') {
                    if (this.config[country]['spaceBeforeCurrency']) result += ' ';
                  if (!hideCurrency) {
                    result += currency;
                  }
                    if (this.config[country]['spaceAfterCurrency']) result += ' ';
                }
            }

            return result;

    }
}


